import { target } from "@github/catalyst";
import { controller } from "./controller";

@controller
export default class XaFormatValueElement extends HTMLElement {
  @target input: HTMLInputElement | undefined;

  connectedCallback(): void {
    if (this.input && this.getAttribute("type") === "phone") {
      this.input.value = this._inputOnInputHandler(this.input?.value);
      this.input?.addEventListener("input", () => {
        if (this.input && this.getAttribute("type") === "phone") {
          this.input.value = this._inputOnInputHandler(this.input?.value);
        }
      });
    }
  }

  _inputOnInputHandler(value: string): string {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    }
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  }
}

declare global {
  interface Window {
    XaFormatValueElement: typeof XaFormatValueElement;
  }
  interface HTMLElementTagNameMap {
    "xa-format-value": XaFormatValueElement;
  }
}

if (!window.customElements.get("xa-format-value")) {
  window.XaFormatValueElement = XaFormatValueElement;
  window.customElements.define("xa-format-value", XaFormatValueElement);
}
